import "./home.scss";

import { Card, Container } from "react-bootstrap";
import { collection, getDocs, query } from "firebase/firestore";
import { useEffect, useState } from "react";

import { db } from "../../firebase/firebase-config";

const getAllCustomers = async () => {
  try {
    const q = query(collection(db, "customers"));
    const querySnapshot = await getDocs(q);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    return data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    return [];
  }
};

const getAllUsers = async () => {
  try {
    const q = query(collection(db, "users"));
    const querySnapshot = await getDocs(q);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    return data;
  } catch (error) {
    console.error("Error fetching users:", error);
    return [];
  }
};

const getAllBusinesses = async () => {
  try {
    const q = query(collection(db, "businesses"));
    const querySnapshot = await getDocs(q);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    return data;
  } catch (error) {
    console.error("Error fetching businesses:", error);
    return [];
  }
};

const getAllB2BUsers = async () => {
  try {
    const q = query(collection(db, "b2bUsers"));
    const querySnapshot = await getDocs(q);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    return data;
  } catch (error) {
    console.error("Error fetching B2B users:", error);
    return [];
  }
};

const getAllRequests = async () => {
  try {
    const q = query(collection(db, "requests"));
    const querySnapshot = await getDocs(q);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    return data;
  } catch (error) {
    console.error("Error fetching requests:", error);
    return [];
  }
};

const Home = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [customersData, setCustomersData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [businessesData, setBusinessesData] = useState([]);
  const [b2bUsersData, setB2BUsersData] = useState([]);
  const [requestsData, setRequestsData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoadingData(true);
      try {
        const [customers, users, businesses, b2bUsers, requests] =
          await Promise.all([
            getAllCustomers(),
            getAllUsers(),
            getAllBusinesses(),
            getAllB2BUsers(),
            getAllRequests(),
          ]);
        setCustomersData(customers);
        setUsersData(users);
        setBusinessesData(businesses);
        setB2BUsersData(b2bUsers);
        setRequestsData(requests);
      } catch (error) {
        console.error("Error fetching all data for Home component:", error);
      } finally {
        setLoadingData(false);
      }
    };

    fetchAllData();
  }, []);

  const formattedDate = currentDateTime.toLocaleDateString("es-ES", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const formattedTime = currentDateTime.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const totalCustomers = customersData.length;
  const totalUsers = usersData.length;
  const totalBusinesses = businessesData.length;
  const totalB2BUsers = b2bUsersData.length;
  const totalPendingRequests = requestsData.filter(
    (req) => req.status === "pending"
  ).length;

  const getGreeting = () => "Bienvenido!";

  if (loadingData) {
    return (
      <div className="home-full d-flex justify-content-center align-items-center">
        <p className="text-muted">Cargando datos...</p>
      </div>
    );
  }

  return (
    <div className="home-full">
      <Container className="home-content">
        <h1>{getGreeting()}</h1>
        <p className="lead">
          Hoy es {formattedDate} - {formattedTime}
        </p>

        <div className="home-stats-grid">
          <Card className="stat-card">
            <Card.Body>
              <Card.Title>
                <h3>{totalCustomers}</h3>
              </Card.Title>
              <Card.Text>Clientes Registrados</Card.Text>
              <p className="text-success">
                <small>0 nuevos esta semana</small>
              </p>
            </Card.Body>
          </Card>

          <Card className="stat-card">
            <Card.Body>
              <Card.Title>
                <h3>{totalBusinesses}</h3>
              </Card.Title>
              <Card.Text>Negocios Asociados</Card.Text>
              <p className="text-success">
                <small>0 nuevos esta semana</small>
              </p>
            </Card.Body>
          </Card>

          <Card className="stat-card">
            <Card.Body>
              <Card.Title>
                <h3>{totalUsers}</h3>
              </Card.Title>
              <Card.Text>Usuarios Generales</Card.Text>
              <p className="text-info">
                <small>0 activos hoy</small>
              </p>
            </Card.Body>
          </Card>

          <Card className="stat-card">
            <Card.Body>
              <Card.Title>
                <h3>{totalB2BUsers}</h3>
              </Card.Title>
              <Card.Text>Usuarios B2B</Card.Text>
              <p className="text-info">
                <small>0 activos hoy</small>
              </p>
            </Card.Body>
          </Card>

          <Card className="stat-card">
            <Card.Body>
              <Card.Title>
                <h3>{totalPendingRequests}</h3>
              </Card.Title>
              <Card.Text>Solicitudes Pendientes</Card.Text>
              <p className="text-warning">
                <small>Devoluciones: --</small>
              </p>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default Home;
